import { useMatches } from 'react-router-dom';
import { getFlatRoutes } from './routes-utls';
import { routes } from '../app/routes';
import {
  RouteConfig,
  RouteMatch,
  RouteConfigWithParams,
} from '../types/route.types';
import { Route } from '../types/navigation.types';

function arraysEqual(arr1: string[], arr2: string[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const sortedArr1 = arr1.slice().sort();
  const sortedArr2 = arr2.slice().sort();

  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) {
      return false;
    }
  }

  return true;
}

export const useRouteConfig = (): RouteConfigWithParams | undefined => {
  const matches = useMatches();

  const routeConfigs = getFlatRoutes(routes)
    .filter((r): r is Route & { path: string } => Boolean(r.path))
    .map((route) => ({
      params: route.path
        .split('/')
        .filter((p: string) => p.startsWith(':'))
        .map((p: string) => p.replace(':', '')),
      ...route,
    }));

  if (matches.length === 0) {
    return undefined;
  }

  const lastMatch = matches[matches.length - 1];
  const routeConfig: RouteMatch = {
    params: lastMatch.params as Record<string, string>,
    pathname: lastMatch.pathname,
    paramKeys: Object.keys(lastMatch.params as Record<string, string>).slice(1),
    entityType: lastMatch.pathname.split('/')[2],
  };

  const routeMatch: RouteMatch = {
    ...routeConfig,
    paramKeys: Object.keys(routeConfig.params).slice(1),
    entityType: routeConfig.pathname.split('/')[2],
  };

  const currentRouteConfig = routeConfigs.find((config) => {
    const routeMatchKeys = Object.keys(routeMatch.params);
    // remove accountId param
    routeMatchKeys.shift();

    const hasSameParams = arraysEqual(config.params, routeMatchKeys);

    return (
      hasSameParams &&
      (config.path.includes(routeMatch.entityType) ||
        config.entityTypes?.includes(routeMatch.entityType))
    );
  });

  return currentRouteConfig as RouteConfigWithParams | undefined;
};
